//--------------------------
// has outstanding SR rolls
//--------------------------
export default function hasOutstandingSRRolls(combatants) {
  console.log("--------------------------")
  console.log("IN hasOutstandingSRRolls")
  //--------------------------------------
  // where not all combatants have rolled
  //--------------------------------------
  let os = combatants.some((a) => a.sr_roll == 0);
  // console.log("hasOutstandingSRRolls = " + os)
  return os;
}
